import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { LoadingCellRendererComponent } from './loading-cell-renderer.component';

@NgModule({
  declarations: [LoadingCellRendererComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [LoadingCellRendererComponent],
})
export class LoadingCellRendererModule {}
